import { useCallback } from 'react';

import {
  alpha,
  Box,
  Button,
  Dialog,
  DialogContent,
  makeStyles,
} from '@material-ui/core';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import LaunchOutlinedIcon from '@material-ui/icons/LaunchOutlined';
import PhoneIcon from '@material-ui/icons/Phone';
import ReplyIcon from '@material-ui/icons/Reply';
import copy from 'copy-to-clipboard';
import { useSnackbar } from 'notistack';

import { WppButtonsTypeEnum, WppButtonType } from 'store/reducers/templates';

import DialogHeader from './DialogHeader';

const useStyles = makeStyles(({ palette, spacing }) => ({
  button: {
    color: 'inherit',
    padding: spacing(1.5, 2),
    marginBlock: spacing(0.5),
    justifyContent: 'flex-start',
  },
  dialogContent: {
    paddingInline: spacing(2),
  },
  divider: {
    backgroundColor: alpha(palette.text.secondary, 0.2),
  },
}));

const getButtonIcon = (type: WppButtonType['type']) => {
  switch (type) {
    case WppButtonsTypeEnum.URL:
      return <LaunchOutlinedIcon />;
    case WppButtonsTypeEnum.PHONE_NUMBER:
      return <PhoneIcon />;
    case WppButtonsTypeEnum.COPY_CODE:
      return <FileCopyIcon />;
    case WppButtonsTypeEnum.QUICK_REPLY:
      return <ReplyIcon />;
    default:
      return <PhoneIcon />;
  }
};

interface TemplateListOptionsProps {
  open: boolean;
  onClose: () => void;
  buttons: WppButtonType[];
}

export default function TemplateListOptions({
  open,
  onClose,
  buttons = [],
}: TemplateListOptionsProps) {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();

  const handleClickButton = useCallback(
    (button: WppButtonType) => {
      if (button.type === WppButtonsTypeEnum.COPY_CODE) {
        copy(button?.example?.[0] || '');
        enqueueSnackbar('Texto copiado para a área de transferência.');
      } else if (button.type === WppButtonsTypeEnum.URL && button.url) {
        window.open(button.url, '_blank');
      }
    },
    [enqueueSnackbar],
  );
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      aria-labelledby="template-actions-dialog"
    >
      <DialogHeader title="Ações disponíveis" onClose={onClose} />

      <DialogContent className={classes.dialogContent}>
        {buttons.map((button, index) => (
          <Box key={`${button.type}-${button.text || index}`}>
            <Button
              className={classes.button}
              fullWidth
              size="small"
              startIcon={getButtonIcon(button.type)}
              onClick={() => handleClickButton(button)}
            >
              {button.text}
            </Button>
          </Box>
        ))}
      </DialogContent>
    </Dialog>
  );
}
